import Axios from '@/services/axios-instance/axios.service';

class StripeService {
  async sendFormData(req) {
    const { data } = await Axios.post(`/stripe/pay`, req);
    return data;
  }
  async getCustomerDetails(customerId) {
    const { data } = await Axios.get(`/stripe/customer/${customerId}`);
    return data;
  }
  async createSetupIntent(req) {
    const { data } = await Axios.post(`/stripe/create-setup-intent`, req);
    return data;
  }
  async attachPaymentMethod(req) {
    const { data } = await Axios.post(`/stripe/attach-payment-method`, req);
    return data;
  }
}

export default new StripeService();
